import Vue from 'vue';
import manageAppsUrls from '../../../../urls/manageAppsUrls';

const getRowByAppId = (payload, data) => {

  var rows = data.rows;
  var columns = data.columns;

  var column;

  switch (payload.platform) {
    case 1:
      column = 'androidAppId';
      break;
    case 2:
      column = 'iosAppId';
      break;
    case 3:
    case 4:
      column = 'assocId';
      break;
  }

  var id = payload[column];
  var index = getColumnIndex(column, columns);

  var row = rows.find((c) => {
    return c[index] == id;
  });

  return row;

}

const getColumnIndex = (column, columns) => {
  var index = columns.findIndex((c) => {
    return c == column;
  });
  return index;
}

const getAppsToRestoreDelete = (androidAppId, iosAppId) => {
  var arr = [];
  if (androidAppId)
    arr.push(androidAppId);
  if (iosAppId)
    arr.push(iosAppId);
  return arr;
}

const createAppsToRestoreDeleteRequest = (payload, toDelete) => {
  var request = {
    pba_ids: getAppsToRestoreDelete(payload.androidAppId, payload.iosAppId),
    to_delete: toDelete
  }

  return {
    app_data: JSON.stringify(request)
  };
}

const state = {

  manageAppsData: null

}

const getters = {

  manageAppsData(state) {

    return state.manageAppsData;

  }

}

const mutations = {

}

const actions = {

  fetchManageApps(context, payload) {

    return new Promise((resolve, reject) => {

      Vue.$http.post(manageAppsUrls.getApps, payload).then((response) => {

        context.state.manageAppsData = response.data;
        resolve(response.data);

      }).catch((error) => {

        reject();

      });

    });

  },

  deleteApp(context, payload) {

    return new Promise((resolve, reject) => {

      var request = createAppsToRestoreDeleteRequest(payload, true);

      Vue.$http.post(manageAppsUrls.deleteRestoreApp, request).then((response) => {

        var result = JSON.parse(response.data.d);

        if (result.success) {
          var data = {...context.state.manageAppsData};
          var row = getRowByAppId(payload, data);
          var isDeletedIndex = getColumnIndex('isDeleted', data.columns);
          row[isDeletedIndex] = true;
          context.state.manageAppsData = data;
        }

        resolve(result);

      }).catch((error) => {

        reject();

      });

    });

  },

  restoreApp(context, payload) {

    return new Promise((resolve, reject) => {

      var request = createAppsToRestoreDeleteRequest(payload, false);

      Vue.$http.post(manageAppsUrls.deleteRestoreApp, request).then((response) => {

        var result = JSON.parse(response.data.d);

        if (result.success) {
          var data = {...context.state.manageAppsData};
          var row = getRowByAppId(payload, data);
          var isDeletedIndex = getColumnIndex('isDeleted', data.columns);
          row[isDeletedIndex] = false;
          context.state.manageAppsData = data;
        }

        resolve(result);

      }).catch((error) => {

        reject();

      });

    });

  },

  fixAppUrl(context, payload) {

    return new Promise((resolve, reject) => {

      var request = {
        pubAppId: payload.pubAppId,
        packageUrl: payload.packageUrl,
        platform: payload.platformName,
        isFullUrl: payload.isFullUrl
      }

      Vue.$http.post(manageAppsUrls.fixAppUrl, request).then((response) => {

        var result = JSON.parse(response.data.d);

        if (result.status) {
          var data = {...context.state.manageAppsData};
          var row = getRowByAppId(payload, data);
          row[getColumnIndex('iconUrl', data.columns)] = result.imageUrl;
          row[getColumnIndex('androidSetupProgress', data.columns)] = result.androidSetupProgress;
          row[getColumnIndex('iosSetupProgress', data.columns)] = result.iosSetupProgress;
          context.state.manageAppsData = data;
        }

        resolve(result);

      }).catch((error) => {

        reject();

      });

    });

  }

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/App/ManageApps/store/manageApps.js